export class StoreSwitcherDrawer extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    /* ?country= in URL check - Start */
    // eslint-disable-next-line compat/compat
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    })
    this.countryParam = params.country

    if (this.countryParam !== null) {
      const countryCode = this.countryParam

      this.setupCountrySelectorDrawer(countryCode)
    } else if (!this.noLocationStored) {
      const countryCode = window.localStorage.getItem(this.userLocationName)

      this.setupCountrySelectorDrawer(countryCode)
    } else {
      window.BAO.utils
        .fetchJSON('/browsing_context_suggestions.json', {
          method: 'GET',
        })
        .then(res => {
          const countryCode = res.detected_values.country.handle

          this.setupCountrySelectorDrawer(countryCode)
        })
    }

    this.setupListeners()
  }

  setupCountrySelectorDrawer (countryCode) {
    this.createItemsList(countryCode)
  }

  createItemsList (countryCode) {
    Object.entries(this.countries).forEach(([key, value]) => {
      const { name, site, currency } = value
      const isCurrentSite = key.toLowerCase() === countryCode.toLowerCase()
      this.els.items.element.innerHTML += this.createItemElement(
        key,
        site,
        isCurrentSite,
        name,
        currency,
      )
    })
  }

  createItemElement (code, site, isCurrentSite, country, currency) {
    return `<li class="drw-StoreSelector_Item">
      <a
        class="drw-StoreSelector_Link fz-12_13"
        href="${this.sites[site].url}${this.dataset.currentUrl}?country=${code}"
        aria-current="${isCurrentSite ? 'true' : 'false'}"
      >
        ${country} (${currency})

        <span class="drw-StoreSelector_Icon">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 8">
            <path stroke="currentColor" d="M1 4.5 3.5 7 9 1"/>
          </svg>
        </span>
      </a>
    </li>`
  }

  get noLocationStored () {
    return (
      window.localStorage.getItem(this.userLocationName) == null ||
      (window.localStorage.getItem(this.userLocationName) === undefined &&
        !window.Shopify.designMode)
    )
  }

  get userLocationName () {
    return 'BAO-localization'
  }

  get sites () {
    return {
      DE: {
        url: 'https://de.lumene.com',
      },
      FI: {
        url: 'https://fi.lumene.com',
      },
      ROW: {
        url: 'https://lumene.com',
      },
      SWE: {
        url: 'https://se.lumene.com',
      },
      UK: {
        url: 'https://uk.lumene.com',
      },
      US: {
        url: 'https://us.lumene.com',
      },
    }
  }

  get countries () {
    return window.theme.countries
  }
}

if (!customElements.get('store-switcher-drawer')) {
  customElements.define('store-switcher-drawer', StoreSwitcherDrawer)
}
